var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.4 35.4",
    style: {
      enableBackground: "new 0 0 35.4 35.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5F8A8B;}\n\t.st1{fill:#D29B4D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_307",
    transform: "translate(0 15.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_305",
    transform: "translate(0 0.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3955",
    className: "st0",
    d: "M0.6,14C0.2,14,0,13.7,0,13.4c0-0.2,0.1-0.3,0.2-0.4C10.3,5.5,22.3,1,34.8,0 c0.3,0,0.6,0.2,0.6,0.5c0,0.3-0.2,0.6-0.5,0.6c0,0-0.1,0-0.1,0c-12.3,1-24.1,5.4-34,12.8C0.8,13.9,0.7,14,0.6,14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_303",
    transform: "translate(5.299 3.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3956",
    className: "st0",
    d: "M0.6,16.2C0.2,16.2,0,16,0,15.7c0-0.2,0.1-0.3,0.2-0.4C8.5,7.8,18.6,2.6,29.4,0 C29.7,0,30,0.2,30.1,0.5C30.2,0.7,30,1,29.7,1.1C19,3.6,9.1,8.8,0.9,16.1C0.8,16.2,0.7,16.2,0.6,16.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_304",
    transform: "translate(19.137 8.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3957",
    className: "st0",
    d: "M0.6,11.3c-0.3,0-0.6-0.2-0.6-0.6c0-0.2,0.1-0.3,0.2-0.4C4.8,6.2,9.9,2.8,15.5,0.1 c0.3-0.1,0.6,0,0.7,0.3c0.1,0.3,0,0.6-0.3,0.7C10.5,3.7,5.5,7.1,0.9,11.2C0.8,11.3,0.7,11.3,0.6,11.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_306",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3958",
    className: "st0",
    d: "M18.6,4.6c-0.1,0-0.1,0-0.2,0l-0.3-0.1l0,0C12.4,2.6,6.5,1.4,0.5,1.1C0.2,1.1,0,0.8,0,0.5 C0,0.2,0.3,0,0.6,0c6.1,0.3,12.1,1.5,17.8,3.4l0.3,0.1c0.3,0.1,0.5,0.4,0.4,0.7C19,4.4,18.8,4.6,18.6,4.6L18.6,4.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_311",
    transform: "translate(5.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_308",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3959",
    className: "st1",
    d: "M7.7,12.5c-2,0.1-4-0.6-5.4-2c-1.9-2-2.6-5.2-2.1-9.7c0-0.1,0-0.2,0-0.2 c0-0.2,0.2-0.4,0.4-0.5C0.8,0,1.1,0,1.2,0.2c0.7,0.9,2.2,1.3,3.9,1.6C7,2.2,8.8,2.9,10.4,4c1.7,1.4,2.3,3.7,1.9,6.7 c0,0.3-0.3,0.5-0.6,0.5c-0.3,0-0.5-0.3-0.5-0.6c0.8-6-2.8-6.8-6.4-7.6C3.6,2.7,2.3,2.3,1.2,1.7C0.9,4.4,1.1,7.8,3,9.7 c1.3,1.3,3.2,1.9,5.7,1.6c0.3,0,0.6,0.2,0.6,0.5c0,0.3-0.2,0.5-0.5,0.6C8.4,12.5,8,12.5,7.7,12.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_309",
    transform: "translate(14.956 3.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3960",
    className: "st1",
    d: "M2.5,8.7c-0.6,0-1.3-0.1-1.9-0.2c-0.2,0-0.4-0.2-0.4-0.4c-0.5-1.7-0.2-3.6,0.9-5 C3.4,0.1,8.4,0,8.6,0c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0,0,0c0,0.2-0.1,4.7-2.9,6.9C5.2,8.3,3.9,8.7,2.5,8.7z M1.2,7.5 c1.5,0.4,3.1,0.1,4.3-0.9C7.4,5.1,7.9,2.4,8,1.1C6.7,1.3,3.5,1.8,2,3.7C1.2,4.8,0.9,6.2,1.2,7.5L1.2,7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_310",
    transform: "translate(6.849 6.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3961",
    className: "st1",
    d: "M6.6,9.4c-0.3,0-0.6-0.2-0.6-0.6C6,6.6,5,4.5,3.2,3.1c-0.9-0.8-1.9-1.5-2.9-2 C0.1,0.9-0.1,0.6,0.1,0.3C0.2,0.1,0.5-0.1,0.8,0C1.9,0.6,3,1.3,4,2.2c2,1.6,3.2,4.1,3.2,6.6C7.2,9.2,6.9,9.4,6.6,9.4 C6.6,9.4,6.6,9.4,6.6,9.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.f10a19948554ce66ada510819b2e8c06.svg";
export { ForwardRef as ReactComponent };